<template>
  <div class="cascader-wrapper" :class="{'is-opening': popupVisbile, 'is-custom-label': showCustLabel}" @keyup.8="reset">
    <h-input class="cascader-input" @click.native="show" :size="size" @focus="show" suffixIcon="el-icon-arrow-down" :placeholder="placeholder" ref="reference" :name="name" v-model="selects" readonly></h-input>
    <div class="custom-label" v-if="showCustLabel">
      <slot name="label" :label="selects"></slot>
    </div>

    <popover v-model="popupVisbile" :responsive="responsive" :reference="$refs.reference && $refs.reference.$el" :append-to-body="appendToBody">
      <slot></slot>
    </popover>
  </div>
</template>

<style type="text/css">

.cascader-wrapper {
  display: inline-block;
  position: relative;
}

.cascader-wrapper.is-custom-label .cascader-input {
  opacity: 0;
  z-index: 10;
}

.cascader-wrapper .custom-label {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  z-index: 0;
}

.cascader-wrapper .el-input__inner {
  cursor: pointer;
}

.cascader-wrapper .el-popper {
  width: 100%;
  padding: 0;
}

.cascader-wrapper .mint-popup-bottom.mint-popup {
  padding: 0;
}

.cascader-wrapper.is-opening .el-input__suffix {
  transform: translateY(-50%) rotate(180deg);
}
</style>

<script type="text/javascript">
import hInput from '../input';
import Popover from '../popover';

export default {
  components: {
    Popover,
    // Popup,
    hInput
  },

  props: {
    selects: String,
    // visible: Boolean,
    placeholder: String,
    name: String,
    size: String,
    value: String,
    responsive: Boolean,
    appendToBody: Boolean
  },
  watch: {
    // 触发 vmodel
    selects (v) {
      this.$emit('input', v);
    }
  },
  computed: {
    showCustLabel () {
      return this.$scopedSlots.label && this.selects;
    }
  },
  methods: {
    close () {
      this.popupVisbile = false;
      this.$emit('visbileChange', false);
    },
    show () {
      this.popupVisbile = true;
      this.$emit('visbileChange', true);
    },
    reset () {
      this.$emit('reset');
    }
  },
  data () {
    return {
      popupVisbile: false
    };
  }
};
</script>
